<template>
  <div class="flex items-center justify-center space-x-2">
    <button
      v-for="star in 5"
      :key="star"
      role="button"
      :class="
        star <= modelValue
          ? 'text-text-warning-primary'
          : 'text-situational-lightgrey'
      "
      @click="setRating(star)"
    >
      <StarIcon />
    </button>
  </div>
</template>

<script setup lang="ts">
  import StarIcon from '../assets/star-icon.svg?component';

  withDefaults(
    defineProps<{
      modelValue: number;
      maxStars?: number;
    }>(),
    {
      modelValue: 0,
      maxStars: 5,
    },
  );

  const emit = defineEmits(['update:modelValue']);

  const setRating = (val: number) => {
    emit('update:modelValue', val);
  };
</script>
